import React, { useEffect, useState } from "react";
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonPage,
} from "@ionic/react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tabs,
  Tab,
  Box,
  TextField,
  Chip,
  Pagination,
  MenuItem,
  Select,
} from "@mui/material";
import axios from "axios";
import { baseUrl, config, requestID } from "../../../common/utils";

type PurchaseOrder = {
  id: string;
  product_name: string;
  request_id: string;
  product_id: string;
  quantity: number;
  approved_qty: number;
  audit_qty: number;
  unit_price: string;
  total_price: string;
  status: string;
  suppliedStatus?: string;
};

const statusFilters = [
  { value: "unaudited", label: "Unaudited" },
  { value: "audited", label: "Audited" },
];

const PurchaseOrderAuditSales = () => {
  const [orders, setOrders] = useState<PurchaseOrder[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<PurchaseOrder[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState<"audited" | "unaudited">("unaudited");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(8);
  const [searchTerm, setSearchTerm] = useState("");

  const [confirmDialog, setConfirmDialog] = useState<{
    open: boolean;
    id: string;
    action: "approved" | "rejected";
  }>({ open: false, id: "", action: "approved" });

  // State for the confirmation dialog fields
  const [totalPrice, setTotalPrice] = useState("");
  const [formattedTotalPrice, setFormattedTotalPrice] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [formattedPaymentAmount, setFormattedPaymentAmount] = useState("");
  const [balance, setBalance] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  const isAuditMode = filter === "unaudited";

  useEffect(() => {
    fetchOrders();
  }, [filter]);

  useEffect(() => {
    filterOrders();
  }, [orders, searchTerm]);

  useEffect(() => {
    const total = parseFloat(totalPrice) || 0;
    const payment = parseFloat(paymentAmount) || 0;
    const newBalance = total - payment;
    setBalance(formatCurrency(String(newBalance)));
  }, [totalPrice, paymentAmount]);

  const fetchOrders = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("requestID", requestID());

    const endpoint =
      filter === "audited"
        ? "warehouses/getApprovedAuditOrder"
        : "warehouses/getUnapprovedAuditOrderSales";

    axios
      .post(baseUrl() + endpoint, formData, config)
      .then((res) => {
        console.log(res);
        const ordersArray = Array.isArray(res.data)
          ? res.data
          : res.data?.data || res.data?.orders || [];

        const processedOrders = ordersArray.map((order: any) => ({
          ...order,
          quantity: Number(order.quantity),
          approved_qty: Number(order.approved_qty),
          audit_qty: Number(order.audit_qty ?? order.quantity),
          total_price:
            order.total_price ||
            (
              Number(order.audit_qty ?? order.quantity) *
              Number(order.unit_price)
            ).toFixed(2),
        }));
        setOrders(processedOrders);
      })
      .catch((err) => {
        console.error(`Error fetching ${filter} orders:`, err);
        alert(`Failed to fetch ${filter} purchase orders`);
      })
      .finally(() => setIsLoading(false));
  };

  const filterOrders = () => {
    let filtered = [...orders];

    if (searchTerm) {
      filtered = filtered.filter(
        (order) =>
          order.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          order.request_id.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredOrders(filtered);
    setCurrentPage(1);
  };

  const handleQuantityChange = (id: string, value: string) => {
    const updatedOrders = orders.map((order) =>
      order.id === id
        ? {
            ...order,
            audit_qty: Number(value),
            total_price: (Number(value) * Number(order.unit_price)).toFixed(2),
          }
        : order
    );
    setOrders(updatedOrders);
  };

  const confirmStatusChange = (id: string, action: "approved" | "rejected") => {
    const order = orders.find((o) => o.id === id);
    if (!order) {
      alert("Error: Could not find the selected order.");
      return;
    }

    // Initialize dialog state
    setTotalPrice(order.total_price);
    setFormattedTotalPrice(formatCurrency(order.total_price));
    setPaymentMethod("");
    setPaymentAmount("");
    setFormattedPaymentAmount("");
    setBalance(formatCurrency(order.total_price)); // Initially, balance equals total price

    setConfirmDialog({ open: true, id, action });
  };
 const [loading, setLoading] = useState(false);

  // const handleStatusChange = async () => {
  //   setLoading(true);
  //   try {
  //     // your confirm logic here (API call, etc.)
  //     await new Promise((resolve) => setTimeout(resolve, 2000)); // fake delay
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleStatusChange = () => {

        setLoading(true);

    const { id, action } = confirmDialog;
    const order = orders.find((o) => o.id === id);
    if (!order) return;

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("request_id", order.request_id);
    formData.append("product_id", order.product_id);
    formData.append("status", action);
        formData.append("amount", parseFloat(paymentAmount).toFixed(2));
        
                formData.append("totalPrice", parseFloat(totalPrice).toFixed(2));

    formData.append("paymentMethod", paymentMethod);
    formData.append("quantity", String(order.audit_qty));

    axios
      .post(baseUrl() + "warehouses/approveAuditOrderSales", formData, config)
      .then((res) => {
        console.log(res);
        alert(`Order ${action}`);
        fetchOrders();
      })
      .catch((err) => {
        console.error("Error approving audit order:", err);
        alert("Failed to update order status");
      })
      .finally(() => {
           setLoading(false);
        setConfirmDialog({ open: false, id: "", action: "approved" });
      });
  };

  const handleFilterChange = (
    event: React.SyntheticEvent,
    newValue: "audited" | "unaudited"
  ) => {
    setFilter(newValue);
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredOrders.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const getStatusChip = (status?: string) => {
    switch (status) {
      case "1":
        return <Chip label="Supplied" color="success" variant="outlined" />;
      case "0":
        return <Chip label="Not Supplied" color="error" variant="outlined" />;
      default:
        return (
          <Chip label="Pending Audit" color="warning" variant="outlined" />
        );
    }
  };
 const formatCurrency = (value: string) => {
    if (!value) return "";
    const number = parseFloat(value.replace(/[^0-9]/g, "")); // remove non-numeric
    if (isNaN(number)) return "";
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 0,
    }).format(number);
  };

  const handlePaymentAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    let numericString = input.replace(/[^0-9]/g, "");
    let numericValue = parseFloat(numericString);

    const total = parseFloat(totalPrice) || 0;
    if (numericValue > total) {
      numericValue = total;
      numericString = String(total);
    }
    
    setPaymentAmount(numericString);
    setFormattedPaymentAmount(formatCurrency(numericString));
  };

  const handleTotalPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const numeric = input.replace(/[^0-9]/g, "");
    setTotalPrice(numeric);
    setFormattedTotalPrice(formatCurrency(numeric));
  };
 
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Purchase Order Audit</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <Box sx={{ p: 3 }}>
          {/* Filter and Search Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
            }}
          >
            <TextField
              label="Search Products or Request ID"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ width: { xs: "100%", sm: 300 } }}
            />

            <Tabs
              value={filter}
              onChange={handleFilterChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              {statusFilters.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </Tabs>
          </Box>

          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh",
                flexDirection: "column",
              }}
            >
              <CircularProgress />
              <Typography variant="body1" sx={{ mt: 2 }}>
                Loading purchase orders...
              </Typography>
            </Box>
          ) : currentRows.length > 0 ? (
            <>
              <TableContainer
                component={Paper}
                elevation={3}
                sx={{
                  mb: 3,
                  maxHeight: "calc(100vh - 300px)",
                  overflow: "auto",
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }}>Product</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Requested Qty
                      </TableCell>
                       <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Approved Qty
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">
                        Received Qty
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                      {/* <TableCell sx={{ fontWeight: 'bold' }}>Unit Price</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Total Price</TableCell> */}
                      {isAuditMode && (
                        <TableCell sx={{ fontWeight: "bold" }}>
                          Actions
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentRows.map((order) => (
                      <TableRow key={order.id}>
                        <TableCell>{order.product_name}</TableCell>
                        <TableCell align="right">
                          {order.quantity}
                        </TableCell>
                         <TableCell align="right">
                          {order.approved_qty}
                        </TableCell>
                        {/* <TableCell align="right"> */}
                        <TableCell align="right">
                          <TextField
                            type="number"
                            size="small"
                            value={order.audit_qty ?? ""}
                            onChange={(e) => {
                              const inputValue = Number(e.target.value);
                              const max = Number(order.approved_qty);

                              if (!isAuditMode) return;

                              // Enforce max value
                              const safeValue =
                                inputValue > max ? max : inputValue;

                              handleQuantityChange(order.id, String(safeValue));
                            }}
                            inputProps={{
                              min: 0,
                              max: Number(order.approved_qty), // still shows spinner limits
                            }}
                            sx={{ width: 80 }}
                            disabled={!isAuditMode}
                          />
                        </TableCell>

                        <TableCell>
                          {getStatusChip(order.suppliedStatus)}
                        </TableCell>
                        {/* <TableCell>₦{order.unit_price}</TableCell>
                        <TableCell align="right">₦{order.total_price}</TableCell> */}
                        {isAuditMode && (
                          <TableCell>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() =>
                                confirmStatusChange(order.id, "approved")
                              }
                              disabled={order.audit_qty <= 0}
                            >
                              Approve
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  showFirstButton
                  showLastButton
                />
              </Box>

              {/* Summary */}
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="subtitle1">
                  Total Items: <strong>{filteredOrders.length}</strong>
                </Typography>
                {/* <Typography variant="subtitle1">
                  Total Amount:{" "}
                  <strong>
                    ₦
                    {filteredOrders
                      .reduce(
                        (sum, order) => sum + Number(order.total_price),
                        0
                      )
                      .toFixed(2)}
                  </strong>
                </Typography> */}
              </Box>
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh",
                flexDirection: "column",
              }}
            >
              <Typography variant="h6" sx={{ mb: 1 }}>
                No {filter} purchase orders found
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {searchTerm
                  ? "Try a different search term"
                  : "Check back later for new orders"}
              </Typography>
            </Box>
          )}

          <Dialog
      open={confirmDialog.open}
      onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Confirm Approval & Payment</DialogTitle>
      <DialogContent>
        {/* Total Order Amount */}
        <TextField
          label="Total Order Amount"
          value={formattedTotalPrice}
          onChange={handleTotalPriceChange}
          fullWidth
          sx={{ mb: 2, mt: 1 }}
        />

        {/* Payment Method Select */}
        <Select
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
          displayEmpty
          fullWidth
          sx={{ mb: 2 }}
        >
          <MenuItem value="">Select Payment Method</MenuItem>
          <MenuItem value="cash">Cash</MenuItem>
          <MenuItem value="transfer">Bank Transfer</MenuItem>
          <MenuItem value="card">Card</MenuItem>
        </Select>

        {/* Payment Amount Input */}
        <TextField
          label="Payment Amount"
          value={formattedPaymentAmount}
          onChange={handlePaymentAmountChange}
          fullWidth
          sx={{ mb: 2 }}
        />

        {/* Balance Display */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
            <Typography variant="h6">Balance:</Typography>
            <Typography variant="h6" color={parseFloat(balance.replace(/[^0-9-]/g, '')) < 0 ? 'error' : 'inherit'}>
                {balance}
            </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleStatusChange}
          color="primary"
          variant="contained"
          disabled={loading || !paymentMethod || !paymentAmount || !totalPrice}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default PurchaseOrderAuditSales;
